var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67.75,
    height: 28,
    role: "img",
    "aria-label": "GIT",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GIT") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.75,
    height: 28,
    fill: "#f44d27"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 100
  }, /*#__PURE__*/React.createElement("image", {
    x: 9,
    y: 7,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJ3aGl0ZSIgcm9sZT0iaW1nIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlPkdpdDwvdGl0bGU+PHBhdGggZD0iTTIzLjU0NiAxMC45M0wxMy4wNjcuNDUyYy0uNjA0LS42MDMtMS41ODItLjYwMy0yLjE4OCAwTDguNzA4IDIuNjI3bDIuNzYgMi43NmMuNjQ1LS4yMTUgMS4zNzktLjA3IDEuODg5LjQ0MS41MTYuNTE1LjY1OCAxLjI1OC40MzggMS45bDIuNjU4IDIuNjZjLjY0NS0uMjIzIDEuMzg3LS4wNzggMS45LjQzNS43MjEuNzIuNzIxIDEuODg0IDAgMi42MDQtLjcxOS43MTktMS44ODEuNzE5LTIuNiAwLS41MzktLjU0MS0uNjc0LTEuMzM3LS40MDQtMS45OTZMMTIuODYgOC45NTV2Ni41MjVjLjE3Ni4wODYuMzQyLjIwMy40ODguMzQ4LjcxMy43MjEuNzEzIDEuODgzIDAgMi42LS43MTkuNzIxLTEuODg5LjcyMS0yLjYwOSAwLS43MTktLjcxOS0uNzE5LTEuODc5IDAtMi41OTguMTgyLS4xOC4zODctLjMxNi42MDUtLjQwNlY4LjgzNWMtLjIxNy0uMDkxLS40MjQtLjIyMi0uNi0uNDAxLS41NDUtLjU0NS0uNjc2LTEuMzQyLS4zOTYtMi4wMDlMNy42MzYgMy43LjQ1IDEwLjg4MWMtLjYuNjA1LS42IDEuNTg0IDAgMi4xODlsMTAuNDggMTAuNDc3Yy42MDQuNjA0IDEuNTgyLjYwNCAyLjE4NiAwbDEwLjQzLTEwLjQzYy42MDUtLjYwMy42MDUtMS41ODIgMC0yLjE4NyIvPjwvc3ZnPg=="
  }), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.1)",
    x: 438.75,
    y: 175,
    textLength: 237.5,
    fill: "#fff",
    fontWeight: "bold"
  }, "GIT"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.1ee336a0b184ebcd26324b3632d48955.svg";
export { ForwardRef as ReactComponent };